export default __webpack_public_path__ + "static/bg-cta-ed9fffe0018bcbea87020f4ecbe8b9e8.jpg";